// Tariff Accommodation Criteria
export interface TariffHotelCriteria {
    hotelCurrency: string;
    hotelCountry: string;
    hotelName: string;
    hotelTariffYear: number;
    tourRegions: string;
    hotelStarRating: string;
    hotelFromDate: string;
    hotelCity: string;
    hotelKeyWords: string;
    hotelToDate: string;
    hotelResort: string;
    hotelInternalRating: string;
    noOfResults: number;
    rowId: number;
}


export class TariffHotelCriteria {
    constructor() {
        this.reset();
    }

    public reset(): void {
        this.hotelCurrency = '';
        this.hotelCountry = '';
        this.hotelName = '';
        this.hotelTariffYear = new Date().getFullYear();
        this.tourRegions = '';
        this.hotelStarRating = '';
        this.hotelFromDate = '';
        this.hotelCity = '';
        this.hotelKeyWords = '';
        this.hotelToDate = '';
        this.hotelResort = '';
        this.hotelInternalRating = '';
        this.noOfResults = 10000;
        this.rowId = 0;
    }
}
